import { useState } from "react";
import { AdminService } from "../../../core/services/AdminService";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../theme/Component/BasicButton";
import { PrintJson } from "../../theme/Component/PrintJson";

export const RestaurarRP=()=>{

     const service = new AdminService();

     const [response,setResponse] = useState<any>({});
     const [data,setData] = useState<any>({
        Year:_single.getCurrenYear(),
        IDEmployee:_single.getAccountID()
     });

    const restarRPDocuments = ()=>{
        service.restarRPDocuments(data.Year,data.IDEmployee).subscribe(
            (resp:any)=>{
                if(resp.DataBeanProperties.ObjectValue)
                {
                    setResponse(resp.DataBeanProperties.ObjectValue);
                }
            }
        )
    }


    return(
        <div className="row">
            <div className="col-md-4">
                <YearSelector value={data.Year} onChange={(e)=>{setData({...Date,"Year":e})}}/>
            </div>
            <div className="col-md-4 mt-4">
                <BasicButton icon="" eventClick={restarRPDocuments}>Ejecutar</BasicButton>
            </div>
            <div className="col-md-12">
                <PrintJson json={response}/>
            </div>

        </div>
    )
}